import React from 'react'
import { Easing, interpolate, useCurrentFrame, useVideoConfig } from 'remotion'
import { Speaker } from '../types'
import Participant from './Participant'
import { useResponsiveSceneProps } from './ResponsiveSceneContext'

export interface VerticalParticipantsProps {
  speakers: Speaker[]
}

export default function VerticalParticipants({
  speakers,
}: VerticalParticipantsProps) {
  const { u, w, h, orientation } = useResponsiveSceneProps()
  const frame = useCurrentFrame()
  const { fps } = useVideoConfig()
  const time = frame / fps

  const bottom = {
    landscape: u(9),
    square: u(6),
    portrait: u(9),
  }[orientation]

  const gapSize = {
    landscape: u(1),
    square: u(1),
    portrait: u(1.75),
  }[orientation]

  const x = (t: number) =>
    interpolate(t, [0, 0.5], [u(3), 0], {
      extrapolateLeft: 'clamp',
      extrapolateRight: 'clamp',
      easing: Easing.out(Easing.exp),
    })

  const opacity = (t: number) =>
    interpolate(t, [0, 0.25], [0, 1], {
      extrapolateLeft: 'clamp',
      extrapolateRight: 'clamp',
    })

  const item = (t: number) => ({
    opacity: opacity(t),
    transform: `translateX(${x(t)}px)`,
  })

  return (
    <div
      className="absolute flex flex-col"
      style={{
        bottom,
        left: u(4),
        transform: `translateY(50%)`,
      }}
    >
      {speakers.map((speaker, index) => (
        <React.Fragment key={speaker.name}>
          {index > 0 && <div style={{ height: gapSize }} />}

          <div style={item(time - 0.1)}>
            <Participant size={u(2.5)} speaker={speaker} />
          </div>
        </React.Fragment>
      ))}
    </div>
  )
}
